import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { faFileInvoiceDollar } from '@fortawesome/pro-solid-svg-icons';

import { addStep } from './store/workflow/actions';
import EmptyState from 'components/empty_state';
import AddControl from 'components/add_control';

const VoucherApprovalWorkflowEmptyState = ({ addStep }) => {
  return <React.Fragment>
    <EmptyState
      icon={faFileInvoiceDollar}
      subheader='Get started by clicking on the "Add Workflow" button'
    >
      <AddControl onClick={addStep}>Add Workflow</AddControl>
    </EmptyState>
  </React.Fragment>;
};

VoucherApprovalWorkflowEmptyState.propTypes = {
  addStep: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  addStep,
};

export default connect(null, mapDispatchToProps)(VoucherApprovalWorkflowEmptyState);
